import { render, staticRenderFns } from "./SelecaoAssinatura.vue?vue&type=template&id=b9123f4a&scoped=true&"
var script = {}
import style0 from "./SelecaoAssinatura.vue?vue&type=style&index=0&id=b9123f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9123f4a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9123f4a')) {
      api.createRecord('b9123f4a', component.options)
    } else {
      api.reload('b9123f4a', component.options)
    }
    module.hot.accept("./SelecaoAssinatura.vue?vue&type=template&id=b9123f4a&scoped=true&", function () {
      api.rerender('b9123f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/ForaDoAr/SelecaoAssinatura.vue"
export default component.exports